import React from 'react'
import SyncIcon from '@material-ui/icons/Sync'
import styled from '@emotion/styled'
import { IconWrapper } from './DownloadIconButton'

type Props = {
  onClick: () => void
}

const StyledSyncButton = styled(SyncIcon)`
  font-size: 30px !important;

  &.MuiSvgIcon-root {
    fill: white;
  }
`

const SyncIconButton = (props: Props) => (
  <IconWrapper {...props} onClick={props.onClick}>
    <StyledSyncButton />
  </IconWrapper>
)

export default SyncIconButton
